// Runtime, hostname-based environment detection - one build works correctly
// regardless of which domain/CloudFront distribution it's actually served
// from, rather than needing a separate build per environment. Matches the
// same fix applied to VOZCARE-BMS-PORTAL (2026-09-30).
//
// Found 2026-09-30: .env/.env.production both pointed at
// vozcare_customer_portal / vozcare_customers (no environment suffix) - the
// OLD, legacy backend, not the real vozcare_customer_portal_prod /
// vozcare_customers_prod this session's own backend work deployed.
// .env.development was already correct. Verified all 4 values below
// directly against live AWS (Cognito user pools + AppSync APIs in both
// accounts), not copied from the old env files.
//
// 2026-10-15: legacy is retired - this build has NO connection to the legacy
// backend any more (the old "old_prod" entry and its fallthrough were
// removed). Two backends, selected by hostname:
//   - dev.portal.vozcare.com (or localhost)      -> dev
//   - everything else (portal.vozcare.com, atdc.vozcare.com, ...) -> prod
//
// History, kept for context:
// 2026-10-08: split "prod" into "prod" (genuinely separate new-prod backend)
// and "old_prod" (the original legacy backend) at the user's explicit
// direction - legacy and new-prod must share zero resources (no common
// AppSync API, no common Cognito pool), connected only by the temporary
// data sync running outside this frontend. Before this split, both
// portal.vozcare.com and prod.portal.vozcare.com resolved to the same
// "prod" key, so changing its values would have silently repointed
// legacy's real, live traffic too - old_prod preserves legacy's original,
// unchanged values so portal.vozcare.com is completely unaffected by the
// "prod" change below.
const ENVIRONMENTS = {
  dev: {
    userPoolId: "ap-south-1_KvO70xN9G",
    userPoolClientId: "43v0ubq8bmlt75l1hqcoaf0nb6",
    appsyncEndpoint:
      "https://m4hojzhline25fgaeoyomzmsva.appsync-api.ap-south-1.amazonaws.com/graphql",
    websocketUrl: "wss://18m1cdr1h2.execute-api.ap-south-1.amazonaws.com/dev",
  },
  prod: {
    // New-prod, prod.portal.vozcare.com only. Points at the genuinely
    // separate vozcare_customer_portal_prod AppSync API and its own
    // Cognito pool (confirmed distinct from the retired legacy pool/API). Altamayez's user confirmed CONFIRMED in this pool. New-prod
    // currently has data for Altamayez (VOZ-CUST-2) only - any other
    // customer logging in at this hostname will not find their data here.
    userPoolId: "ap-south-1_8C98AZetE",
    userPoolClientId: "2p39070bkk5klood1noqkj25gr",
    appsyncEndpoint:
      "https://i3bdowaiuvcgbd77po5bu5ja7q.appsync-api.ap-south-1.amazonaws.com/graphql",
    websocketUrl: "wss://31wlodisub.execute-api.ap-south-1.amazonaws.com/prod",
  },
};

// Altamayez cutover (2026-10-15): these former legacy domains now serve the
// new prod build. Listed explicitly so a future "dev" substring rule can never
// misroute them.
const NEW_PROD_HOSTS = [
  "portal.vozcare.com",
  "www.portal.vozcare.com",
  "atdc.vozcare.com",
  "www.atdc.vozcare.com",
];

export function resolveEnvironment(hostname = window.location.hostname) {
  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return "dev";
  }
  if (NEW_PROD_HOSTS.includes(hostname)) {
    return "prod";
  }
  if (hostname.includes("dev")) {
    return "dev";
  }
  // Anything else - including unknown hosts such as the CloudFront default
  // domain - is new prod. Never fall back to legacy.
  return "prod";
}

export function getAwsConfig(hostname) {
  return ENVIRONMENTS[resolveEnvironment(hostname)];
}

// Browser WebSocket address for this environment (report-ready pop-ups, notifications).
// dev/prod each have their OWN API created by the backend's WebsocketStack.
// Returns "" when an environment has none configured, so callers can skip connecting instead of using the wrong one.
export function getWebsocketUrl(hostname) {
  return getAwsConfig(hostname).websocketUrl || "";
}
